import $ from 'jquery';

export default class {
	constructor(data) {
		this.data = data || {};
		this.checkDataLayer();
		return this;
	}

	checkDataLayer() {
		if (typeof window.dataLayer == 'undefined' ) {
			window.dataLayer = {};
			window.dataLayer.push = function (data) {
				console.log('dataLayer.push', data);
			};
		}
	}

	setData(data, replace = false) {
		this.data = replace ? data : $.extend(true, {}, this.data, data);
		return this;
	}

	push(data) {
		this.setData(data);
		window.dataLayer.push(this.data);
	}
}



// WEBPACK FOOTER //
// ./app/modules/analytics/analytics.js